// import { ProductKey } from '@atlassiansox/asc-product-catalog';
// import {
//   PricingCalculation,
//   PricingPeriod
// } from '@atlassian/bxp-product-pricing';
//
// import { usePricingCalculator } from '../contexts';
// import { AsyncResult, useAsync } from './use-async';
//
// export type PricingResult = PricingCalculation & {
//   readonly units: number;
//   readonly period: PricingPeriod;
// };
//
// export function usePricing(
//   productKey: ProductKey,
//   units: number,
//   period: PricingPeriod,
//   currencyIsoCode: string
// ): AsyncResult<PricingResult> {
//   const calculator = usePricingCalculator();
//   return useAsync(async () => {
//     const pricing = await calculator.calculatePrice({
//       productKey,
//       units,
//       period,
//       currencyIsoCode
//     });
//     return {
//       ...pricing,
//       units,
//       period
//     };
//   }, [productKey, units, period, currencyIsoCode]);
// }
